import { render, staticRenderFns } from "./questionsIndex.vue?vue&type=template&id=4b78bdf4&"
import script from "./questionsIndex.vue?vue&type=script&lang=js&"
export * from "./questionsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports